import { motion } from "framer-motion";

const seeAndDo = [
  {
    kicker: "Imprescindible",
    title: "La Alhambra",
    detail:
      "El monumento más visitado de España. Comprad las entradas con semanas de antelación — se agotan rápido. Id temprano o al atardecer.",
  },
  {
    kicker: "Barrio con encanto",
    title: "El Albaicín",
    detail:
      "El casco antiguo árabe, de calles empinadas y Cármenes. Subid al Mirador de San Nicolás para la mejor vista de la Alhambra con Sierra Nevada detrás.",
  },
  {
    kicker: "Noche & flamenco",
    title: "Sacromonte",
    detail:
      "El barrio de las cuevas y el flamenco. Si os apetece vivir una experiencia muy granadina, os recomendamos asistir a un espectáculo de flamenco en una de sus cuevas históricas.",
  },
];

const tapas = [
  {
    name: "Los Manueles",
    note: "Cocina tradicional granadina en un ambiente con solera.",
  },
  {
    name: "Tocateja",
    note: "Tapeo con toques modernos y muy buen producto — muy nuestro.",
  },
  {
    name: "Bodegas Castañeda",
    note: "Clásico del centro. Tapas generosas y vermut de grifo.",
  },
  {
    name: "Bar Los Diamantes",
    note: "El templo del pescaíto frito. Siempre lleno, siempre bueno.",
  },
  {
    name: "Calle Navas",
    note: "La calle de tapeo por excelencia — id de bar en bar.",
  },
];

const GranadaGuide = () => {
  return (
    <section
      id="granada"
      data-testid="granada-section"
      className="border-t border-[#c9c3b3] py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="flex items-start justify-between">
          <p className="corner-label text-[#8a8580]">(03) — Qué hacer</p>
        </div>

        <div className="mt-16 grid grid-cols-12 gap-6 md:gap-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="col-span-12 md:col-span-7"
          >
            <h2 className="display-xl">
              Qué hacer
              <br />
              en Granada.
            </h2>
          </motion.div>
          <div className="col-span-12 md:col-span-5 md:pt-8">
            <p className="body-lead max-w-md">
              Si alargáis la escapada, Granada os va a enamorar. Aquí van
              nuestras recomendaciones para ver la ciudad y, sobre todo, para
              tapear como se debe — que aquí la tapa sigue siendo gratis.
            </p>
          </div>
        </div>

        {/* Qué ver */}
        <div className="mt-16 grid grid-cols-1 border-t border-[#c9c3b3] md:grid-cols-3">
          {seeAndDo.map((s, i) => (
            <motion.article
              key={s.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.08 }}
              data-testid={`granada-see-${i}`}
              className={`flex flex-col gap-4 border-b border-[#c9c3b3] py-12 md:py-14 ${
                i > 0 ? "md:border-l md:pl-10" : ""
              } md:pr-8`}
            >
              <div className="flex items-center justify-between">
                <span className="corner-label text-[#8a8580]">{s.kicker}</span>
                <span className="corner-label text-[#8a8580]">0{i + 1}</span>
              </div>
              <h3 className="display-md">{s.title}</h3>
              <p className="body-lead">{s.detail}</p>
            </motion.article>
          ))}
        </div>

        {/* Tapas & bares */}
        <div className="mt-16 grid grid-cols-12 gap-6 md:gap-10">
          <div className="col-span-12 md:col-span-4">
            <p className="corner-label text-[#8a8580]">Tapas & bares</p>
            <h3 className="mt-4 display-md">Dónde tapear</h3>
          </div>
          <div className="col-span-12 md:col-span-8">
            <div className="border-t border-[#c9c3b3]">
              {tapas.map((t, i) => (
                <motion.div
                  key={t.name}
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.6, delay: i * 0.05 }}
                  data-testid={`granada-tapas-${i}`}
                  className="grid grid-cols-12 gap-4 border-b border-[#c9c3b3] py-6 md:gap-8"
                >
                  <div className="col-span-12 md:col-span-4">
                    <p className="display-md">{t.name}</p>
                  </div>
                  <div className="col-span-12 md:col-span-8">
                    <p className="body-lead">{t.note}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GranadaGuide;
